import { isNumber, isString } from "lodash";

function toDoubleDigit(num) {
    return String(num).padStart(2, '0');
}

export const getTimerStringFormat = (number) => {
    let minutes = 0;
    let seconds = 0;

    if (isNumber(number)) {
        minutes = Math.floor(number / 60);
        seconds = number % 60;
    }

    return `${toDoubleDigit(minutes)} : ${toDoubleDigit(seconds)}`;
}

export const convertToParagraphs = (string, splitBy = '\n\n') => {
    if (isString(string)) {
        return string.split(splitBy).map(str => `<p>${str}</p>`).join("");
    }

    return '';
}